// extracted by mini-css-extract-plugin
export var chip = "_r0-0";
export var icon = "_r0-1";
export var remove = "_r0-2";
export var removeIcon = "_r0-3";